import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

function EditStaffPage({ staff, onSave, onClose }) {
  const [editedStaff, setEditedStaff] = useState({
    ...staff,
    hireDate: staff.hireDate.toDate()
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedStaff(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDateChange = (date) => {
    setEditedStaff(prev => ({
      ...prev,
      hireDate: date
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(editedStaff);
  };

  return (
    <div className="p-4">
      <h2 className="text-3xl font-bold mb-6">Edit Staff</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block mb-2 font-semibold">Name:</label>
          <input
            type="text"
            name="name"
            value={editedStaff.name}
            onChange={handleInputChange}
            className="w-full p-2 border rounded"
          />
        </div>
        <div className="mb-4">
          <label className="block mb-2 font-semibold">Hire Date:</label>
          <DatePicker
            selected={editedStaff.hireDate}
            onChange={handleDateChange}
            className="w-full p-2 border rounded"
          />
        </div>
        <div className="flex justify-end mt-6">
          <button type="submit" className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 mr-2">Save</button>
          <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-300 text-black rounded hover:bg-gray-400">Cancel</button>
        </div>
      </form>
    </div>
  );
}

export default EditStaffPage;